import { isAfter, startOfDay } from "date-fns";

/**
 * `InputDate`'s `minDate`/`maxDate` reach only the calendar popover — a *typed* date is
 * parsed and accepted without consulting either bound, and `required` never compares the
 * two fields. So every real guarantee lives here, in react-hook-form `validate` rules.
 */

export const isNotInTheFuture = (value: Date | null): true | string => {
  if (!value) {
    return true;
  }

  if (isAfter(startOfDay(value), startOfDay(new Date()))) {
    return "Date cannot be in the future";
  }

  return true;
};

export const isStartOnOrBeforeEnd = (
  startDate: Date | null,
  endDate: Date | null,
): true | string => {
  if (!startDate || !endDate) {
    return true;
  }

  if (isAfter(startOfDay(startDate), startOfDay(endDate))) {
    return "Start date must be on or before the end date";
  }

  return true;
};

export const isEndOnOrAfterStart = (
  endDate: Date | null,
  startDate: Date | null,
): true | string => {
  if (!startDate || !endDate) {
    return true;
  }

  if (isAfter(startOfDay(startDate), startOfDay(endDate))) {
    return "End date must be on or after the start date";
  }

  return true;
};
